import { SVGProps } from 'react';

const FileKey2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6m10-8v4a2 2 0 0 0 2 2h4m-10 2-4.5 4.5M9 11l1 1m-4 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default FileKey2;
